import { createSelector } from '@ngrx/store';
import { getIngredientByPLU } from '@shared/state';
import { isWizzardIngredientSelected } from '../isWizzardIngredientSelected';

export const isWizzardIngredientSelectable = (PLU: number) =>
    createSelector(getIngredientByPLU(PLU), isWizzardIngredientSelected(PLU), (ingredient, isSelected) => {
        const isObligatory = 'IngredientMode' in ingredient && ingredient.IngredientMode === OLO.Enums.INGREDIENT_MODE.OBLIGATORY;

        return ingredient.ExclusionState === OLO.Enums.INGREDIENT_EXCLUSION_STATE.AVAILABLE && (!isSelected || !isObligatory);
    });
